import { createFileRoute } from "@tanstack/react-router";
import {
    ContactLinkRoute,
    providerOutreachLinkRoute,
} from "@/features/provider-outreach";

export const Route = createFileRoute("/k/$token")({
    loader: providerOutreachLinkRoute.loader,
    preload: false,
    head: providerOutreachLinkRoute.head,
    headers: providerOutreachLinkRoute.headers,
    component: ContactLinkRoute,
});
